import React, { Suspense } from 'react'
import Sidebar from '../../../common/components/Sidebar'
import RootLoader from '../../../Root/RootLoader'
import { z } from '../../style'
import Overlay from 'common/components/Overlay'
import BoardList from './BoardList'
import BottomBar from './SidabarBottomBar'
import SidebarFilters from './SidebarFilters'
import TopBar from './SidebarTopBar'

export default ({ folder, anon, section, activityShowing, toggleActivity }) => {
  return (
    <Sidebar>
      <Suspense fallback={<RootLoader step="Sidebar" />}>
        <TopBar />

        {!folder && !anon && <SidebarFilters />}

        <BoardList section={section} />

        <BottomBar />

        {activityShowing && (
          <Overlay z={z.activityOverlay} onClick={toggleActivity} />
        )}
      </Suspense>
    </Sidebar>
  )
}
